const main = {
  apiUrl: "https://api-womens.spovizz.cloud.vigitalsolutions.com",
  frontendUrl: "https://womens.spovizz.cloud.vigitalsolutions.com/frontend",
  videoUrl: "https://video.spovizz.com",
  client: "womens_live",
};

const config = {
  ...main,
  testMode: false,
  appName: "Spo|Vizz",
  screenshotsUrl: `${main.apiUrl}/screenshots/[[TEMPLATE]]/[[UUID]]/[[TYPE]].jpg`,
  chatbox: {
    active: false,
  },
  refreshVideoInterval: 10000,
  dashboardTemplatesRefreshInterval: 5000,
  clientBodyClass: "app-opta app-fcb",
};

export default config;
